import { motion } from "framer-motion";
import { Reveal } from "../Reveal";

const SUPPORTERS = [
  { name: "Startup India", src: "/logos/startup-india-logo.png", w: 1080, h: 264 },
  { name: "MeitY Startup Hub", src: "/logos/meity-startup-hub.png", w: 6025, h: 2454 },
  { name: "LNCT KALCHURI Incubation Center · Anupam", src: "/logos/lnct-anupam-incubation.jpg", w: 200, h: 56 },
  { name: "Madhya Pradesh Startup Centre", src: "/logos/mp-startup-centre.png", w: 726, h: 398 },
];

export default function CredibilityStrip() {
  return (
    <section
      data-testid="credibility-strip"
      className="relative py-14 border-t border-[#E6E9F1] bg-white"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-8">
        <Reveal className="grid gap-10 md:grid-cols-2 md:divide-x md:divide-[#E6E9F1]">
          <div className="flex flex-col items-center gap-6 md:pr-10">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#94A3B8]">
              Supported by
            </span>
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-6">
              {SUPPORTERS.map((s, i) => (
                <motion.img
                  key={s.name}
                  data-testid="supporter-logo"
                  src={s.src}
                  alt={s.name}
                  width={s.w}
                  height={s.h}
                  loading="lazy"
                  initial={{ opacity: 0, scale: 0.92 }}
                  whileInView={{ opacity: 0.7, scale: 1 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.4, delay: i * 0.07, ease: [0.23, 1, 0.32, 1] }}
                  className="h-9 w-auto object-contain grayscale transition-[filter,opacity] duration-200 hover:grayscale-0 hover:!opacity-100"
                />
              ))}
            </div>
          </div>

          <div className="flex flex-col items-center gap-6 md:pl-10">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#94A3B8]">
              Founder Featured by
            </span>
            <img
              data-testid="featured-in-logos"
              src="/logos/featured.PNG"
              alt="Featured in Dainik Bhaskar, Patrika, News18 India, Nai Dunia and DD"
              width="692"
              height="85"
              loading="lazy"
              className="h-11 md:h-14 w-auto max-w-full object-contain opacity-80 transition-opacity duration-200 hover:opacity-100"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
